import React, { memo } from "react";
import { Modal } from 'react-bootstrap';

const CustomMedel = ({ children, isOpen, size, dialogClassName }) => {
  return (

    <Modal show={isOpen} size={size} centered dialogClassName={dialogClassName}>
      {children}
    </Modal>

  )
}


export default memo(CustomMedel);
